interface Props {
  title: string;
  /** From `failureReason`. */
  reason: string;
  /** Builds the failed part again in place, keeping the game; left out when only a reload can. */
  onRetry?: () => void;
}

/**
 * Stands in front of everything when the table cannot be built or the page stopped, so a
 * player never faces a black or white screen without a word (client-audio-engine:bugs#2).
 */
export function FailurePanel({ title, reason, onRetry }: Props) {
  return (
    <div
      className="failure-panel"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="failure-title"
      aria-describedby="failure-reason"
    >
      <div className="menu-card">
        <h2 id="failure-title" className="failure-title">
          {title}
        </h2>
        <p id="failure-reason" className="menu-text">
          {reason}
        </p>
        <div className="menu-buttons">
          {onRetry && (
            <button type="button" className="primary" onClick={onRetry} autoFocus>
              Try again
            </button>
          )}
          <button type="button" onClick={() => window.location.reload()} autoFocus={!onRetry}>
            Reload the page
          </button>
        </div>
      </div>
    </div>
  );
}
